import React from 'react';

class Feature extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    /**
     * Your ajax will goes here to get data then call setState
     */
  }

  render() {
    return (
      <React.Fragment>
        <div id="features" className={"feature-section ptb-100 " + (this.props.bgColor && this.props.bgColor === 'gray' ? 'gray-light-bg' : '')}>
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-8">
                <div className="section-heading text-center mb-5">
                  <span className="badge badge-primary badge-pill">
                    Social Shopping
                  </span>
                  <h2>
                    Grupos Frisbee <br />
                    <span>compra inteligentemente.</span>
                  </h2>
                  <p>
                    Explora, comparte y ahorra, por que comprar debe ser siempre una experiencia divertida.
                    Un Grupo Frisbee desbloquea precios especiales desde el 25% de descuento en tus productos favoritos.
                    Para formar un Grupo, puedes compartirlo con tus contactos en WhatsApp, Messenger o SMS y ahorra en tus compras.
                  </p>
                </div>
              </div>
            </div>

            <div className="row row-grid align-items-center">
              <div className="col-lg-4">
                <div className="group-title">
                  <h2>Crea un Grupo</h2>
                </div>
                <div className="d-flex align-items-start mb-5">
                  <div className="pr-4">
                    <div className="icon icon-shape icon-color-1 rounded-circle">
                      <span className="ti-face-smile"></span>
                    </div>
                  </div>
                  <div className="icon-text">
                    <h5>Elige tu producto favorito</h5>
                    <p className="mb-0 medium">
                      El producto que más te guste, tiene un Precio Frisbee que lo desbloqueas cuando hayas formado un Grupo Frisbee con un mínimo número de integrantes. 
                    </p>
                  </div>
                </div>
                <div className="d-flex align-items-start mb-5">
                  <div className="pr-4">
                    <div className="icon icon-shape icon-color-2 rounded-circle">
                      <span className="ti-shopping-cart"></span>
                    </div>
                  </div>
                  <div className="icon-text">
                    <h5>Completa tu compra</h5>
                    <p className="mb-0 medium">
                      Realiza tu proceso de compra con tu Precio Frisbee, no te preocupes no te vamos a cobrar hasta que el Grupo se haya completado y todos hayan realizado su pago.
                    </p>
                  </div>
                </div>
                <div className="d-flex align-items-start">
                  <div className="pr-4">
                    <div className="icon icon-shape icon-color-3 rounded-circle">
                      <span className="ti-share"></span>
                    </div>
                  </div>
                  <div className="icon-text">
                    <h5>Invita a tus contactos </h5>
                    <p className="mb-0 medium">
                      Comparte el link de tu grupo con tus contactos en WhatsApp, Messenger y SMS. Todos ahorran comprando en Grupos. No necesitan todos comprar el mismo color y talla de un producto, basta que sea la misma referencia y BAM tienen el Precio Frisbee.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="position-relative" style={{zIndex: 10}}>
                  <img
                    alt="placeholder"
                    src="img/flash-sale-central.png"
                    className="img-center img-fluid"
                  />
                </div>
              </div>
              <div className="col-lg-4">
                <div className="group-title">
                  <h2>Únete a un Grupo</h2>
                </div>
                <div className="d-flex align-items-start mb-5">
                  <div className="pr-4">
                    <div className="icon icon-shape icon-color-4 rounded-circle">
                      <span className="ti-search"></span>
                    </div>
                  </div>
                  <div className="icon-text">
                    <h5>Explora Grupos existentes</h5>
                    <p className="mb-0 medium">
                      Explora tus productos, marcas y estilos favoritos y puedes visualizar los Grupos Frisbee esperando por más integrantes para desbloquear el Precio Frisbee.
                    </p>
                  </div>
                </div>
                <div className="d-flex align-items-start mb-5">
                  <div className="pr-4">
                    <div className="icon icon-shape icon-color-5 rounded-circle">
                      <span className="ti-thumb-up"></span>
                    </div>
                  </div>
                  <div className="icon-text">
                    <h5>Únete a un Grupo</h5>
                    <p className="mb-0 medium">
                      Fácilmente forma parte de un Grupo que está esperando por más integrantes y desbloquea tu Precio Frisbee. Es muy fácil ahorrar y encontrar los mejores descuentos en tus marcas favoritas.
                    </p>
                  </div>
                </div>
                <div className="d-flex align-items-start">
                  <div className="pr-4">
                    <div className="icon icon-shape icon-color-6 rounded-circle">
                      <span className="ti-comments-smiley"></span>
                    </div>
                  </div>
                  <div className="icon-text">
                    <h5>Ahorra y diviértete</h5>
                    <p className="mb-0 medium">
                      Cuando todos los integrantes hayan completado su compra, el Grupo Frisbee se cerrará y tus compras serán despachadas inmediatamente. Recibe tus compras en 48 horas en tu casa y disfruta de tu experiencia Frisbee.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Feature;
